import ProductReview from "@components/experiments/Widgets/ProductReview"
import {
  isConsolidatedPurchasableItem,
  useGetConsolidatedItem,
} from "@hooks/V2/storyblok/useConsolidatedItem"
import React from "react"

const StoryblokProductReview = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ProductReview>) => {
  const getConsolidatedItem = useGetConsolidatedItem()

  const consolidatedItem = getConsolidatedItem(blok?.productConfig)

  if (!isConsolidatedPurchasableItem(consolidatedItem)) {
    return null
  }

  return <ProductReview skus={consolidatedItem.reviewSkus} />
}

export default StoryblokProductReview
